import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import ActionData from "csi/heading/ActionData";
import html from "csi/html";
import declare from "dojo/_base/declare";
import { URL_UOM_TYPE } from "src/c8-platform/type/uom";

const UOMTypeToHeadingMap: Record<string, Set<string>> = {
	Length: new Set(["QtyLength", "QtyLengthUOM"]),
	Each: new Set(["QtyEach", "QtyEachUOM"]),
	Weight: new Set(["QtyWeight", "QtyWeightUOM"]),
};

const UOMTypeForBOMQtyFromMaterialRendererMixin = declare(null, {
	/**
	 * @override
	 * C8-71199 Disables fields based on UOMTypeForBOMQtyFromMaterial
	 */
	toHtmlStatic(
		ctx: Context,
		heading: Heading,
		refNode: HTMLElement,
		actionData: ActionData,
	) {
		const node = ctx.getNode();
		const headingId = heading.m_id;
		const uomTypeURL: string = node.UOMTypeForBOMQtyFromMaterial;
		// Get the uom type from the URL (centric://UOMType/Weight -> Weight)
		const uomType = uomTypeURL.substring(URL_UOM_TYPE.length);
		const fieldsToShow = UOMTypeToHeadingMap[uomType];
		if (
			!uomTypeURL.startsWith(URL_UOM_TYPE) ||
			!uomType ||
			!fieldsToShow ||
			!fieldsToShow.has(headingId)
		) {
			refNode.classList.add(html.CSS_NOT_APPLICABLE);
			return false;
		}
		return this.inherited(arguments);
	},
});

export = UOMTypeForBOMQtyFromMaterialRendererMixin;
